if (!customElements.get('rh-product-upload')) {
  customElements.define(
    'rh-product-upload',
    class RhProductUpload extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.input = this.querySelector('[data-upload-input]');
        this.dropzone = this.querySelector('[data-upload-dropzone]');
        this.status = this.querySelector('[data-upload-status]');
        this.fileNameField = this.querySelector('[data-upload-filename]');
        this.uploadIdField = this.querySelector('[data-upload-id]');
        this.form = this.closest('form');

        this.input.addEventListener('change', () => this.uploadFile(this.input.files[0]));
        ['dragenter', 'dragover'].forEach((eventName) => {
          this.dropzone.addEventListener(eventName, (event) => {
            event.preventDefault();
            this.dropzone.classList.add('is-dragging');
          });
        });
        ['dragleave', 'drop'].forEach((eventName) => {
          this.dropzone.addEventListener(eventName, (event) => {
            event.preventDefault();
            this.dropzone.classList.remove('is-dragging');
          });
        });
        this.dropzone.addEventListener('drop', (event) => this.uploadFile(event.dataTransfer.files[0]));
      }

      setButtonsDisabled(disabled) {
        this.form?.querySelectorAll('button[type="submit"]').forEach((button) => {
          if (disabled) {
            button.dataset.uploadDisabled = button.disabled ? 'already' : 'true';
            button.disabled = true;
          } else if (button.dataset.uploadDisabled === 'true') {
            button.disabled = false;
            delete button.dataset.uploadDisabled;
          }
        });
      }

      resetUpload() {
        this.fileNameField.value = '';
        this.uploadIdField.value = '';
        this.fileNameField.disabled = true;
        this.uploadIdField.disabled = true;
        this.classList.remove('is-success');
      }

      async uploadFile(file) {
        if (!file) return;
        this.resetUpload();
        const maxBytes = Number(this.dataset.maxBytes || 20971520);
        const allowed = /\.(pdf|ai|eps|svg|png|jpe?g|tiff?)$/i;
        if (!allowed.test(file.name)) {
          this.showError('Dieses Dateiformat wird nicht unterstützt.');
          return;
        }
        if (file.size > maxBytes) {
          this.showError('Die Datei ist größer als 20 MB – bitte unten per WeTransfer senden.');
          return;
        }

        this.classList.remove('is-error');
        this.classList.add('is-uploading');
        this.status.textContent = `„${file.name}“ wird sicher hochgeladen …`;
        this.setButtonsDisabled(true);

        try {
          const body = new FormData();
          body.append('file', file, file.name);
          const response = await fetch(this.dataset.endpoint, { method: 'POST', body });
          const result = await response.json().catch(() => ({}));
          if (!response.ok || !result.uploadId) throw new Error(result.error || 'Upload fehlgeschlagen');

          this.fileNameField.value = result.fileName || file.name;
          this.uploadIdField.value = result.uploadId;
          this.fileNameField.disabled = false;
          this.uploadIdField.disabled = false;
          this.classList.remove('is-uploading');
          this.classList.add('is-success');
          this.status.textContent = `✓ ${result.fileName || file.name} ist sicher gespeichert.`;
        } catch (error) {
          this.showError('Upload fehlgeschlagen. Bitte erneut versuchen oder die Datei später senden.');
        } finally {
          this.setButtonsDisabled(false);
        }
      }

      showError(message) {
        this.classList.remove('is-uploading', 'is-success');
        this.classList.add('is-error');
        this.status.textContent = message;
      }
    }
  );
}
